import { useEffect, useState } from "react";
import { Steps } from "antd";

const FormProgress = (props) => {
  const [stepType, setStepType] = useState("navigation");
  const [stepDirection, setStepDirection] = useState("horizontal");
  const handleResize = () => {
    if (window.innerWidth >= 1400) {
      setStepType("navigation");
      setStepDirection("horizontal");
    } else if (window.innerWidth <= 500) {
      setStepType("navigation");
      setStepDirection("vertical");
    } else {
      setStepType("inline");
    }
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleResize);
  });
  const items = [];
  let step = props.progress.step;
  const current = parseInt(step.substring(0, 1)) - 1;
  props.menu.forEach((parts, i) => {
    items.push({
      title: parts.title,
      description: i === current ? props.progress.subTitle : "",
    });
  });

  return (
    <Steps
      current={current}
      percent={props.progress.percent}
      items={items}
      type={stepType}
      size="default"
      direction={stepDirection}
    />
  );
};
export default FormProgress;
